// Mentors list order: every organisation admin, then the mentors, each by name.
const byName = (a, b) => String(a?.name || "").localeCompare(String(b?.name || ""));

export const adminsFirst = (tutors) => {
  const list = (tutors || []).filter(Boolean);
  return [
    ...list.filter((t) => t.role === "clubAdmin").sort(byName),
    ...list.filter((t) => t.role !== "clubAdmin").sort(byName),
  ];
};
